import calcWidth from "./helpers";
import { TopolButtonBlock } from "@/schemas/template/blocks/buttonBlockSchema";
import { v4 as uuidv4 } from "uuid";
import { useMjmlStore } from "@/stores/mjmlStore";
import { useGeneralStore } from "@/stores/generalStore";
import { mergeDeep } from "@/utils/mergeDeep";
import {
  ButtonAttributesSchema,
  TopolCustomBlockData,
  TopolCustomBlockMixContentWithKey,
} from "@/schemas/contentBlock/contentBlockScheme";

export default {
  getData(
    state: any,
    props: { sectionIndex: number; columnIndex: number },
    customBlockData?: TopolCustomBlockData | TopolCustomBlockMixContentWithKey
  ): TopolButtonBlock {
    const mjmlStore = useMjmlStore();
    const generalStore = useGeneralStore();
    const attributes = {
      align: (mjmlStore.getBaseAttrString("mj-button", "align") || "center") as
        | "left"
        | "center"
        | "right",
      "text-align": (mjmlStore.getBaseAttrString("mj-button", "text-align") ||
        "center") as "left" | "center" | "right",
      width: mjmlStore.getBaseAttrString("mj-button", "width") || undefined,
      "background-color": state.mjml.attributes["mj-button"]["background-color"]
        ? state.mjml.attributes["mj-button"]["background-color"]
        : "#e85034",
      color: mjmlStore.getBaseAttrString("mj-button", "color")
        ? mjmlStore.getBaseAttrString("mj-button", "color")
        : "#ffffff",
      "border-radius":
        mjmlStore.getBaseAttrString("mj-button", "border-radius") || "8px",
      border: mjmlStore.getBaseAttrString("mj-button", "border") || undefined,
      "font-size": mjmlStore.getBaseAttrString("mj-button", "font-size")
        ? mjmlStore.getBaseAttrString("mj-button", "font-size")
        : "13px",
      padding:
        mjmlStore.getBaseAttrString("mj-button", "padding") ||
        "20px 20px 20px 20px",
      "inner-padding":
        mjmlStore.getBaseAttrString("mj-button", "inner-padding") ||
        "10px 20px 10px 20px",
      href: "https://google.com",
      "font-family": mjmlStore.getBaseAttrString("mj-button", "font-family")
        ? mjmlStore.getBaseAttrString("mj-button", "font-family")
        : "Helvetica, Arial, sans-serif",
      containerWidth: calcWidth(
        state.mjml.children[0].attributes["containerWidth"],
        state.mjml.children[0].children[props.sectionIndex].children[
          props.columnIndex
        ].attributes["width"]
      ),
      "font-weight": mjmlStore.getBaseAttrString("mj-button", "font-weight")
        ? mjmlStore.getBaseAttrString("mj-button", "font-weight")
        : "normal",
      "font-style": mjmlStore.getBaseAttrString("mj-button", "font-style")
        ? mjmlStore.getBaseAttrString("mj-button", "font-style")
        : "normal",
      "text-transform": mjmlStore.getBaseAttrString(
        "mj-button",
        "text-transform"
      )
        ? mjmlStore.getBaseAttrString("mj-button", "text-transform")
        : "none",
      "text-decoration": mjmlStore.getBaseAttrString(
        "mj-button",
        "text-decoration"
      )
        ? mjmlStore.getBaseAttrString("mj-button", "text-decoration")
        : "none",
      "line-height": mjmlStore.getBaseAttrString("mj-button", "line-height"),
      "letter-spacing": mjmlStore.getBaseAttrString(
        "mj-button",
        "letter-spacing"
      ),
      gradient: mjmlStore.getBaseAttrString("mj-button", "gradient"),
    };

    if (customBlockData && customBlockData.attributes) {
      let attributesToMerge: any = {};
      const buttonAttributes = ButtonAttributesSchema.safeParse(
        customBlockData.attributes
      );
      if (buttonAttributes.success) {
        attributesToMerge = buttonAttributes.data;
      } else {
        const attributesObject = JSON.parse(
          JSON.stringify(customBlockData.attributes)
        );
        buttonAttributes.error.issues.map((issue) => {
          delete attributesObject[issue.path[0]];
        });
        const newRes = ButtonAttributesSchema.safeParse(attributesObject);
        attributesToMerge = newRes.success ? newRes.data : {};
      }
      Object.keys(attributesToMerge).map((key) => {
        if (typeof attributesToMerge[key] === "object") {
          attributesToMerge[key] = attributesToMerge[key].value;
        }
      });
      mergeDeep(attributes, attributesToMerge);
    }

    const defaultContent = generalStore.isRtlLanguage
      ? "<div dir='rtl'>Click me!</div>"
      : "Click me!";

    const baseHover = mjmlStore.getBaseAttr("mj-button", "hover");

    const result: TopolButtonBlock = {
      uid: uuidv4(),
      tagName: "mj-button",
      attributes: attributes,
      content: customBlockData?.content
        ? customBlockData.content
        : defaultContent,
      customKey: customBlockData?.key ? customBlockData.key : null,
    };

    if (baseHover && typeof baseHover === "object") {
      result.hover = { ...baseHover };
    }

    return result;
  },
};
